
eval("define(\'text!oroui/templates/jstree-action.html\',[],function () { return \'<li>\\n    <a href=\"#\" class=\"action\" data-role=\"jstree-action\" title=\"<%= label %>\">\\n        <i class=\"fa-<%= icon %> jstree-actions__icon jstree-actions__icon--<%= icon %>\"></i>\\n        <%= label %>\\n    </a>\\n</li>\\n\';});\n\n//# sourceURL=/text!oroui/templates/jstree-action.html");

